import { useState } from 'react';
import { toast } from 'react-toastify';
import ThemeToggle from '../components/ThemeToggle';
import HealthStatusButton from '../components/HealthStatusButton';
import { EyeOffIcon, EyeOnIcon, LockIcon, UserIcon } from '../components/Icons';
import { loginUser } from '../services/authService';
import '../components/DataPage.css';
import './Login.css';
import '../components/AppLayout.css';

function Login({ onLoginSuccess, onBack }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail || !password) {
      toast.error('Email and password are required.');
      return;
    }

    setSubmitting(true);

    try {
      await loginUser({ email: trimmedEmail, password });
      onLoginSuccess?.();
    } catch (err) {
      toast.error(err.message || 'Sign in failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="login-page"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/ccchaos.svg)`,
      }}
    >
      <header className="login-page__topbar">
        <button
          type="button"
          className="login-page__back"
          onClick={onBack}
          disabled={submitting}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" className="login-page__back-icon">
            <path
              d="M15 18l-6-6 6-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Back</span>
        </button>

        <div className="login-page__topbar-actions">
          <HealthStatusButton />
          <ThemeToggle />
        </div>
      </header>

      <div className="login-page__shell">
        <header className="login-page__brand">
          <div className="login-page__logo">
            <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="EKDANTAYA" />
          </div>
          <h1>WELCOME TO EKDANTAYA</h1>
          <p>Email Marketing System</p>
        </header>

        <form className="login-page__card" onSubmit={handleSubmit} noValidate>
          <h2>Sign in</h2>
          <p className="login-page__subtitle">
            Enter your email and password to sign in.
          </p>

          <label className="login-page__field data-page__modal-field" htmlFor="login-email">
            <span>Email</span>
            <div className="login-page__field-control">
              <span className="login-page__field-icon" aria-hidden="true">
                <UserIcon />
              </span>
              <input
                id="login-email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                autoComplete="username"
                disabled={submitting}
              />
            </div>
          </label>

          <label className="login-page__field data-page__modal-field" htmlFor="login-password">
            <span>Password</span>
            <div className="login-page__field-control login-page__field-control--password">
              <span className="login-page__field-icon" aria-hidden="true">
                <LockIcon />
              </span>
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                disabled={submitting}
              />
              <button
                type="button"
                className="login-page__toggle-password"
                onClick={() => setShowPassword((current) => !current)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                disabled={submitting}
              >
                {showPassword ? <EyeOnIcon /> : <EyeOffIcon />}
              </button>
            </div>
          </label>

          <button type="submit" className="login-page__submit" disabled={submitting}>
            <span>{submitting ? 'Signing in...' : 'Sign In'}</span>
          </button>
        </form>

        <footer className="login-page__footer">
          <p>© {new Date().getFullYear()} EKDANTAYA. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default Login;
